<template>
  <section class="sequence-section">
    <div class="signature-block">
      <p>Reviewer signature</p>
      <p class="sequence-muted">Sign the review to confirm it is complete and accurate.</p>
      <associate-signature
        checkbox-label="I confirm this review is complete and accurate"
        :available-signature="null"
        ref="signatureRef"
        key="adminSignatureKey"
        @checked="$emit('checked', $event)"
        @save-signature="$emit('save-signature', $event)"
      />
    </div>
    <p v-if="showValidation" class="validation-copy">Sign the review before completing it.</p>
  </section>
</template>

<script>
import Signature from '@/components/signature.vue'

export default {
  name: 'SequenceReviewSignature',
  components: {
    'associate-signature': Signature
  },
  props: {
    showValidation: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    saveSignature() {
      return this.$refs.signatureRef.saveSignature()
    }
  }
}
</script>

<style scoped>
.sequence-section {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.signature-block {
  max-width: 520px;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.sequence-muted {
  color: #6b7280;
  font-size: 12px;
}

.validation-copy {
  color: #ef4444;
}
</style>
